var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F2F0F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1494_33327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FCFCFC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1494_33327)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.8999,
    y: 21.3,
    width: 16.5,
    height: 3,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.8999,
    y: 21.3,
    width: 16.5,
    height: 3,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.299805,
    y: 15.3,
    width: 23.7,
    height: 3,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.299805,
    y: 15.3,
    width: 23.7,
    height: 3,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.299805,
    y: 9,
    width: 23.7,
    height: 3,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.299805,
    y: 9,
    width: 23.7,
    height: 3,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.299805,
    y: 3,
    width: 23.7,
    height: 3,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.299805,
    y: 3,
    width: 23.7,
    height: 3,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.3,
    height: 12,
    fill: "#0052B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9002 10.0499L9.0002 10.4999L9.3002 9.59985L8.7002 8.99985H9.6002L9.9002 8.09985L10.3502 8.99985H11.1002L10.5002 9.59985L10.8002 10.4999L9.9002 10.0499Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7 10.0499L4.8 10.4999L5.1 9.59985L4.5 8.99985H5.4L5.7 8.09985L6.15 8.99985H6.9L6.3 9.59985L6.6 10.4999L5.7 10.0499Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4998 10.0499L0.599805 10.4999L0.899805 9.59985L0.299805 8.99985H1.1998L1.4998 8.09985L1.9498 8.99985H2.6998L2.0998 9.59985L2.3998 10.4999L1.4998 10.0499Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9002 6.75005L9.0002 7.20005L9.3002 6.30005L8.7002 5.70005H9.6002L9.9002 4.80005L10.3502 5.70005H11.1002L10.5002 6.30005L10.8002 7.20005L9.9002 6.75005Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9002 3.45L9.0002 3.9L9.3002 3L8.7002 2.4H9.6002L9.9002 1.5L10.3502 2.4H11.1002L10.5002 3L10.8002 3.9L9.9002 3.45Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9002 0.150195L9.0002 0.600195L9.3002 -0.299805L8.7002 -0.899805H9.6002L9.9002 -1.7998L10.3502 -0.899805H11.1002L10.5002 -0.299805L10.8002 0.600195L9.9002 0.150195Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7 3.45L4.8 3.9L5.1 3L4.5 2.4H5.4L5.7 1.5L6.15 2.4H6.9L6.3 3L6.6 3.9L5.7 3.45Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7 6.75005L4.8 7.20005L5.1 6.30005L4.5 5.70005H5.4L5.7 4.80005L6.15 5.70005H6.9L6.3 6.30005L6.6 7.20005L5.7 6.75005Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4998 6.75005L0.599805 7.20005L0.899805 6.30005L0.299805 5.70005H1.1998L1.4998 4.80005L1.9498 5.70005H2.6998L2.0998 6.30005L2.3998 7.20005L1.4998 6.75005Z",
    fill: "#EFEFEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.3a00de65ba8d65b01d9f92bf74a9c603.svg";
export { ForwardRef as ReactComponent };